import {post} from './httpBase';


//绑定身份时获取的验证码
export function getIdentityCode(params) {
    return post('/user/sms', params)
}
//绑定身份司机或调度
export function bindingIdentity(params) {
    return post('/user/wechat/bindopenid', params)
}
//获取已绑定的账号
export function getAccounts(params) {
    return post('/user/wechat/accounts', params)
}




//更换手机号获取验证码
export function getChangePhoneCode(params) {
    return post('/user/wechat/checkphone', params)
}
//更换手机号验证旧号码
export function checkPhone(params) {
    return post('/user/wechat/checksms', params)
}

//获取紧急联系人列表
export function getContacts(params) {
    return post('/user/emergency/list', params)
}
//添加紧急联系人
export function addContact(params) {
    return post('/user/emergency', params)
}

//常用联系人列表
export function getOftenList(params) {
    return post('user/common/list', params)
}
//添加常用联系人
export function addOften(params) {
    return post('user/common/addcommon', params)
}
//删除常用联系人
export function deleteOften(params) {
    return post('user/common/delete', params)
}

//用户优惠券列表
export function discountList(params) {
    return post('user/coupon/couponlistbyperson', params)
}
//用户优惠券详情
export function discountInfo(params) {
    return post('user/coupon/coupondetails', params)
}
//用户领取优惠券
export function getDiscount(params) {
    return post('user/coupon/getcouponbyperson', params)
}


//添加紧急联系人
export function contactsList(params) {
    return post('/urgent/list', params)
}
//意见反馈
export function suggestion(params) {
    return post('/user/feedback', params)
}

// 获取用户信息
export function getUserInfo(params) {
    return post('/v1/login/userInfo', params)
}
//我的退款
export function getUserRefund(params) {
    return post('/v1/refund/my', params)
}

//兼职全职推销员接口
//推销员获取详细信息
export function salesInfo(params) {
    return post('/user/sales/salesinfo', params)
}
//推销员业绩查询
export function salesEndOrder(params) {
    return post('/user/sales/salesperformancesearch', params)
}
//推销员返利记录
export function salesRecord(params) {
    return post('/user/sales/salesrecord', params)
}
//开通钱包明细
export function salesperforwallet(params) {
    return post('/user/sales/salesperforwallet', params)
}
//发送验证码
export function salesgetCode(params) {
    return post('/user/sms/appuser', params)
}
//推销员邀请用户注册
export function salesRegister(params) {
    return post('/user/sales/register', params)
}
//获取套餐优惠券列表
export function discountPackageList(params) {
    return post('/user/coupon/getpackagecouponlistofuser', params)
}
//获取套餐优惠券详情
export function packageInfo(params) {
    return post('/user/coupon/getpackagecoupondetails', params)
}
//套餐优惠券下单
export function packageOrder(params) {
    return post('/user/coupon/addpackagecouponorder', params)
}
//套餐优惠券下单后支付
export function packagePay(params) {
    return post('/order/wxpay/unifiedorder/couponpackageorder', params)
}


//注销用户发送验证码
export function cancelUserCode(params) {
    return post('/user/sms/cancelUser', params)
}
//注销账号
export function cancellation(params) {
    return post('/user/user/cancelUser', params)
}



//添加司机招募信息
export function recruitAdddriver(params) {
    return post('/user/recruit/adddriver', params)
}
//添加合作伙伴信息
export function recruitAddpartner(params) {
    return post('/user/recruit/addpartner', params)
}


// WEBPACK FOOTER //
// ./src/service/memberService.js